<template>
  <div>
    <div v-if="!store.insurances">
      <div class="deck deck--grey pa-1">
        {{t('MessageNoInsurances')}}
      </div>
    </div>
    <div v-if="store.insurances" class="deck deck--grey py-3 px-4">
      <section class="section-top">
        <div>
          <h2 class="headline-3">{{t('InsurancesTitle')}}
            <span v-if="store.company"> {{store.company.name}}</span>
          </h2>
          <p v-html="t('InsurancesText')"></p>
        </div>
      </section>
      <div class="grid">
        <div class="grid__col grid__col--8 mobile-width">
          <section class="section-1">
            <InsuranceItem
              v-for="insurance in store.insurances"
              @toogle="doHandleToogle(insurance)"
              :key="insurance.id"
              :insurance="insurance"
            >
            </InsuranceItem>
          </section>
          <section class="section-2">
            <h2 class="headline-3">
              {{t('InsurancesHeadlineOtherChoose')}}
            </h2>
            <InsuranceItem
              v-for="insurance in store.optionalInsurances"
              @toogle="doHandleToogle(insurance)"
              :key="insurance.id"
              :insurance="insurance"
            >
            </InsuranceItem>
          </section>
        </div>
        <div class="grid__col grid__col--4 rightPanel mobile-width">
          <ContactForm> </ContactForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import t from './../../../mixins/t.js'
import InsuranceItem from './../insurances/InsuranceItem'
import ContactForm from './ContactForm'

export default {
  name: 'InsuranceContact',
  components: {
    InsuranceItem,
    ContactForm
  },
  mixins: [t],
  props: {
    cvr: {
      type: String
    }
  },
  data () {
    return {
      store: this.$parent.store,
      isLoading: false,
      isLoadingBack: false,
      inputInsurance: false,
      isCheckAll: false,
      checkExtraInsurance: false
    }
  },
  created () {
    let appCommercialGuide = document.getElementById('appCommercialGuide')
    if (appCommercialGuide) {
      appCommercialGuide.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'start'})
    }
    if (!this.store.insurances) {
      this.$router.push({ name: 'Questions', params: { cvr: this.store.cvr, step: String(0) } })
    }
  },
  methods: {
    doHandleToogle (insurance) {
      insurance.selected = !insurance.selected
    },
    doNext () {
      this.isLoading = true
    },
    doNextIns (text) {
      let otherInsurances = ''
      otherInsurances = text
      this.checkExtraInsurance = true
      this.store.checkExtraInsurance = this.checkExtraInsurance
      this.store.otherInsurances = otherInsurances
    },
    doOpenIns () {
      this.isCheckAll = !this.isCheckAll
      if (this.isCheckAll) {
        this.inputInsurance = true
      } else {
        this.inputInsurance = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .headline.image img {
    max-width: 150px;
  }
  @media only screen and (max-width: 768px) {
    /* Make the image smaller for mobile view */
    .headline.image img {
      max-width: 75px;
    }
  }
  .headline_gb{
   margin-left: 45px;
  }
  .gbInput {
      height: 2.5rem;
      width: 40%;
      margin-bottom: 2%;
      margin-top: 1%;
      margin-left: 3px;
      padding-left: 1%;
      pointer-events: unset !important;
      font-size: 16px;
    }
  @media only screen and (max-width: 768px) {
    .gbInput {
      height: 2.5rem;
      width: 100%;
      margin-bottom: 2%;
      margin-top: 1%;
      margin-left: 3px;
      padding-left: 1%;
      pointer-events: unset !important;
      font-size: 16px;
    }
  }
  .form__label__text_gb{
    position: relative;
    border-radius: 0.375rem;
    left: 0.063rem;
    display: inline-block;
    margin-left: 47px;
    margin-top: 12px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/insuranceContact/InsuranceContact.vue